<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <div [ngClass]="{'active':isStep2, inactive:isStep1}">
      <button type="button" value="Back" class="back" aria-label="Back" (click)="back()">
        <span class="icon-Previous" aria-hidden="true"></span>
      </button>
    </div>
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"plan.title"|translate}}</h4>
    <button type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <span class="icon-Close" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <form #createPlanForm>
        <div>
          <div [ngClass]="{'active':isStep1, inactive:isStep2}">
            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-textbox #planName (wfmTextboxEvent)="setPlanName($event.target.value)" inputName="planName"
                  [wfmAutoComplete]="'off'"
                  (inputOnInput)="checkFormValidationStatus()" (inputOnBlur)="checkPlanNameExists($event)" [maxLength]="32"
                  inputId="planName" [required]="true" [textValue]="planModel.planName"
                  label='{{ getLabelByFieldName("planName") | async }}' hasFocus=true>
                </wfm-textbox>
              </div>
            </div>
            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #entityType selectName="entityType" selectId="entityType"
                  label="{{ getLabelByFieldName('entityType')|async}}" [items]="entityTypeList"
                  placeHolder="{{ getLabelByFieldName('entityType')|async}}" [disabled]="entityTypeDisabled"
                  (wfmSelectEvent)="updateEntityType($event)" [selectedItem]="planModel.entityType">

                </wfm-select>
              </div>
            </div>


            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #entity selectName="entity" selectId="entity" label="{{getEntityLabel()|async}}"
                  [items]="entityList" placeHolder="{{getEntityLabel()|async}}" [showLoading]="entityListLoading"
                  [disabled]="entityDisabled" (wfmSelectEvent)="updateEntity($event)" [selectedItem]="selectedEntity">

                </wfm-select>
              </div>
            </div>


            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #forecastSource selectName="forecastSource" selectId="forecastSource"
                  label="{{ getLabelByFieldName('forecastSource')|async}}" [items]="forecastSourceList"
                  placeHolder="{{ getLabelByFieldName('forecastSource')|async}}" [disabled]="forecastSourceDisabled"
                  (wfmSelectEvent)="updateForecastSource($event)" [selectedItem]="planModel.forecastSource">
                </wfm-select>
              </div>
            </div>


            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #forecast selectName="forecast" selectId="forecast"
                  label="{{ getLabelByFieldName('forecastLabel')|async}}" [items]="forecastList"
                  placeHolder="{{ getLabelByFieldName('forecastLabel')|async}}" [showLoading]="forecastListLoading"
                  [disabled]="forecastDisabled" (wfmSelectEvent)="updateForecast($event)" [selectedItem]="selectedForecast">

                </wfm-select>
              </div>
            </div>
          </div>
          <div [ngClass]="{'active':isStep2, inactive:isStep1}">
            <div>
              <div class="radio-wrapper">
                <div class="radio">
                    <input type="radio" name="mus" id="mus" [value]="MUType.MUS" [(ngModel)]="selectedMUType" (ngModelChange)="radioChangeHandler($event)">
                    <label for="mus">
                      {{"radio.label.mus"|translate}}
                    </label>
                </div>
                <div class="radio">
                    <input type="radio" name="mus" id="muset" [value]="MUType.MUSET" [(ngModel)]="selectedMUType" (ngModelChange)="radioChangeHandler($event)">
                    <label for="muset">
                      {{"radio.label.muset"|translate}}
                    </label>
                </div>
              </div>
              <div class="row">
                <div class='col-10 form-group'>
                  <div *ngIf="selectedMUType === MUType.MUS; else muSetBlock">
                    <label class="text-uppercase input-label" for="muselect" data-testid="multi-muselect-label">
                      {{"radio." + selectedMUType|translate}}
                    <span class="text-danger"> *</span>
                    </label>
                    <div>
                      <p-multiselect placeholder=" " #muselect name="muselect" [(ngModel)] = "planModel.mus"
                                    [options]="muItems"
                                    [showToggleAll]="false"
                                    [virtualScroll]="true"
                                    [virtualScrollItemSize]="30"
                                    [filter]="false"
                                    (onChange) = "updateSelectedMUs($event)"
                                    [showHeader]="false"
                                    styleClass="bg-lightgrey fullrow"
                                    [title] = "getMUsTooltip()"
                                    panelStyleClass="bg-red">
                        <ng-template let-value pTemplate="selectedItems">
                          <!-- <div *ngIf='value && value.length > 3; else elseBlock'> -->
                          <div class="ui-multiselected-item-token">
                              <span *ngIf='value && value.length > 1; else elseBlock'>{{value.length}} {{"multiselect.text"|translate}}</span>
                              <span *ngIf='value && value.length == 1'>{{value[0].id}} {{value[0].name}}</span>
                          </div>
                          <span *ngIf="!value || value.length === 0" class="ui-multiselected-empty-token">{{"radio."+selectedMUType|translate}}</span>
                        </ng-template>
                      <ng-template let-muItem pTemplate="item">
                        <div title="{{muItem.label}}" class="ui-multiselect-item-custom
                                    {{muItem.value.preferred?'multiselect-bg-white':'multiselect-bg-gray'}}
                                    {{muItem.separator?'item-separator':''}}">
                          <!-- <div class="ui-chkbox ui-widget">
                            <div class="ui-chkbox-box ui-widget ui-corner-all ui-state-default"
                                 [ngClass]="{'ui-state-active': muItem.isSelected}">
                              <span class="ui-chkbox-icon ui-clickable" [ngClass]="{'pi pi-check': muItem.isSelected}"></span>
                            </div>
                          </div> -->
                          <div class="checkbox">
                            <input type = "checkbox" [checked] = "muItem.isSelected"/>
                            <label  class="ui-multiselect-option-label ">{{muItem.label}}</label>
                          </div>
                        </div>
                      </ng-template>

                    </p-multiselect>
                    </div>
                  </div>
                  <ng-template #muSetBlock>
                    <wfm-select #muSet selectName="muSet" selectId="muSet" label="{{getLabelByFieldName('muSetLabel')|async}}"
                            [items]="muSets" placeHolder="{{getLabelByFieldName('muSetLabel')|async}}" [showLoading]="muSetLoading"
                            [disabled]="false" (wfmSelectEvent)="updateMUSet($event)" [selectedItem]="selectedMUSet">

                    </wfm-select>
                    <div id="wfmtext-error" class="invalid-feedback" [ngClass]="{'show-error': (this.planModel.muset && !isMuSetValid)}">
                      <span class="error-message">{{"validation.muset.permissions"|translate}}</span>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div>
                <label class="text-uppercase input-label">
                  {{getLabelByFieldName('weekPickerLabel')|async}}
                  <span class="text-danger"> *</span>
                </label>
                <label class="input-label font-weight-normal sub-label">
                    {{'create.plan.select.unique.weeks' | translate }}
                </label>
              </div>
              <div class="row">
                <div class='col-12 form-group'>
                  <!--<wfm-esp-week-picker #week1 name="week1"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 1)">
                </wfm-esp-week-picker>-->

                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    #week1
                    name="week1"
                    [ngModel]="weekRanges[1]"
                    (ngModelChange)="updateWeekFromRange($event,1)"
                    [startDOW]="startDOW">
                  </sol-date-range-picker>
                </div>
              </div>
              <div class="row">
                <div class='col-12 form-group'>
                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    name="week2"
                    [ngModel]="weekRanges[2]"
                    (ngModelChange)="updateWeekFromRange($event,2)"
                    [startDOW]="startDOW">
                  </sol-date-range-picker>
                  <!--<wfm-esp-week-picker #week2 name="week2"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 2)">
                  </wfm-esp-week-picker>-->
                </div>
              </div>
              <div class="row">
                <div class='col-12 form-group'>
<!--                  <wfm-esp-week-picker #week3 name="week3"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 3)">
                  </wfm-esp-week-picker>-->
                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    name="week3"
                    [ngModel]="weekRanges[3]"
                    (ngModelChange)="updateWeekFromRange($event,3)"
                    [startDOW]="startDOW">
                  </sol-date-range-picker>
                </div>
              </div>
              <div class="row">
                <div class='col-12 form-group'>
                  <!--<wfm-esp-week-picker #week4 name="week4"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 4)">
                  </wfm-esp-week-picker>-->
                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    name="week4"
                    [ngModel]="weekRanges[4]"
                    (ngModelChange)="updateWeekFromRange($event,4)"
                    [startDOW]="startDOW">
                  </sol-date-range-picker>
                </div>
              </div>

              <div id="wfmtext-error" class="invalid-feedback" [ngClass]="{'show-error': hasDuplicateWeeks()}">
                  <span class="error-message">{{"valication.duplicate.week"|translate}}</span>
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button *ngIf="isStep1" buttonText="{{'plan.create.continue.btn'|translate}}"
                     id="create-plan-cont-btn"
                     [isPrimary]="true"
                     [isDisabled]="!enableContinue"
                     (clicked)="continue()"></breeze-button>

      <breeze-button *ngIf="isStep2" buttonText="{{'plan.create.btn'|translate}}"
                     id="create-plan-btn"
                     [isPrimary]="true"
                     [isDisabled]="!enableCreatePlan"
                     (clicked)="createPlan()"></breeze-button>
    </div>
  </div>
</div>
